<template>
  <div v-if="!hidden" class="auth-wizard-backdrop">

    <div class="auth-wizard-container">

      <button class="close-btn" v-if="phoneExists" @click="hideWizard">×</button>

      <div class="wizard-card">

        <div class="title">
          Вход на портал
        </div>

        <!-- DESCRIPTION -->

        <div class="description">

          <p v-if="showLogin">
            • Если у вас ранее был зарегистрирован аккаунт на портале
            Про100 Квиз с номером телефона, то необходимо указать этот номер
            для объединения прежнего аккаунта с профилем ВКонтакте.
            Иначе будет создан новый аккаунт.
          </p>

          <p v-if="showLogin">
            • Если ранее аккаунт не создавался,
            то укажите номер телефона для логина в учётную запись на портале
          </p>

          <p v-if="showVkButton" class="vk-text">
            По причине сбоев в работе мессенджеров просим привязать ВКонтакте
          </p>

        </div>

        <!-- STEPS -->

        <div class="steps">

          <template v-if="phoneExists && !vkExists">

            <div class="step success">
              <div class="circle">1</div>
              <div class="text">Вход по номеру телефона</div>
            </div>

            <div class="step error">
              <div class="circle">2</div>
              <div class="text">Аккаунт ВК не привязан</div>
            </div>

          </template>

          <template v-else-if="vkExists && !phoneExists">

            <div class="step success">
              <div class="circle">1</div>
              <div class="text">Вход через ВКонтакте</div>
            </div>

            <div class="step error">
              <div class="circle">2</div>
              <div class="text">Телефон не привязан</div>
            </div>

          </template>

          <template v-else-if="!phoneExists && !vkExists">

            <div class="step error">
              <div class="circle">1</div>
              <div class="text">Вход через ВКонтакте</div>
            </div>

            <div class="step error">
              <div class="circle">2</div>
              <div class="text">Телефон не привязан</div>
            </div>

          </template>

          <template v-else>

            <div class="step success">
              <div class="circle">1</div>
              <div class="text">Вход по номеру телефона</div>
            </div>

            <div class="step success">
              <div class="circle">2</div>
              <div class="text">Аккаунт ВК привязан</div>
            </div>

          </template>

        </div>

        <!-- LOGIN -->

        <wizard-login
          v-if="showLogin"
          ref="wizardLogin"
          :show-skip-button="!!temp_social_session_id"
          @otp-sent="handleOtpSent"
          @otp-validated="handleOtpValidated"
          @skip-phone="handleSkipPhone"
        />

        <!-- VK -->

        <div v-if="showVkButton" class="vk-wrapper">

          <vk-auth-button
            ref="vkAuthButton"
            title="Привязать ВК"
            flow="bind"
          />

        </div>

        <!-- FINAL -->

        <div v-if="showFinalScreen" class="final-screen">
          Авторизация успешно завершена
        </div>

        <!-- FOOTER -->

        <div class="wizard-footer">

          <button
            class="btn secondary"
            @click="handleSkipPhone"
          >
            Позже
          </button>

          <button
            v-if="!showFinalScreen"
            class="btn primary"
            @click="clickInner"
          >
            Далее
          </button>

          <button
            v-if="showFinalScreen"
            class="btn primary"
            @click="hideWizard"
          >
            Далее
          </button>

        </div>

      </div>

    </div>

  </div>
</template>

<script>

// import Login from "./Login"
import VkAuthButton from "@/components/VkAuthButton"
import { useToast } from "vue-toastification"
import {mapActions} from "vuex"
import api from "@/api/index"
import WizardLogin from "./WizardLogin.vue";

export default {

  name: "AuthWizard",

  components: {
    WizardLogin,
    VkAuthButton
  },

  props: {
    userId: {
      type: [Number, String],
      default: 12
    },
    authApiUrl: {
      type: String,
      default: "/user/{userId}/auth_data/check"
    }
  },

  setup() {
    const toast = useToast()
    return { toast }
  },

  data() {
    return {

      step1: false,
      step2: false,

      phoneExists: false,
      vkExists: false,

      hidden: false,

      loading: true,

      temp_social_session_id: null,

      // Данные для OTP
      pendingOtpCode: null,
      pendingPhone: null,
      wizardLoginRef: null,

      // Финальный экран
      showFinalScreen: false,

    }
  },

  async created() {
    let weAreAuth = this.checkWeAreAuth()
    if (!weAreAuth) {
      this.extractSessionId()
    }
    if (weAreAuth) {
      await this.checkAuthStatus()
    }
  },

  computed: {
    showLogin() {
      // Если показываем финальный экран, скрываем логин
      if (this.showFinalScreen) {
        return false
      }
      if (this.phoneExists && this.vkExists) {
        return false
      }
      if (!this.phoneExists && !this.vkExists) {
        return true
      }
      if (!this.phoneExists && this.vkExists) {
        return true
      }
      if (this.phoneExists && !this.vkExists) {
        return false
      }
      return false
    },

    showVkButton() {
      // Если показываем финальный экран, скрываем кнопку VK
      if (this.showFinalScreen) {
        return false
      }
      if (this.phoneExists && this.vkExists) {
        return false
      }
      if (!this.phoneExists && !this.vkExists) {
        return false
      }
      if (!this.phoneExists && this.vkExists) {
        return false
      }
      if (this.phoneExists && !this.vkExists) {
        return true
      }
      return false
    },
  },

  mounted() {
    this.fetchAuthData()
  },

  methods: {
    ...mapActions([
      'SET_USER_TOKEN',
      'SET_USER_FIELDS',
      'GET_USER_DETAILS'
    ]),

    clickInner() {

      if (this.$refs.wizardLogin) {
        this.$refs.wizardLogin.sendPhone()
        return
      }

      if (this.$refs.vkAuthButton) {
        this.$refs.vkAuthButton.login()
      }

    },

    getMockData() {
      console.log('get mock data')
      return {data: {phone_exists: false, vk_exists: true}, status: 401}
    },

    async fetchAuthData() {
      try {
        // Если есть temp_social_session_id, считаем что VK уже привязан
        if (this.temp_social_session_id) {
          this.vkExists = true
        }
        
        // const url = this.authApiUrl.replace('{userId}', this.userId)
        // const response = await fetch(url)
        const response = this.getMockData()
        if (response) {
          if (response.status === 401) {
            // Пользователь не существует или не авторизован
            this.phoneExists = false
            // Если есть session_id, считаем что VK уже привязан
            if (!this.temp_social_session_id) {
              this.vkExists = false
            }
          } else {
            const data = await response.json()
            // const data = response.data
            this.phoneExists = data.phone_exists || false
            this.vkExists = data.vk_exists || false
          }
        }
      } catch (error) {
        console.error('Failed to fetch auth data:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleOtpSent(data) {
      // Сохраняем OTP код и телефон для последующей валидации
      this.pendingOtpCode = data.code
      this.pendingPhone = data.phone
      console.log('OTP отправлен:', data)
    },
    
    async handleOtpValidated(data) {
      // OTP код введен пользователем
      this.pendingOtpCode = data.code
      this.pendingPhone = data.phone
      
      // Создаем пользователя с OTP кодом
      await this.createUserWithOtp(data.phone, data.code)
    },
    
    async handleSkipPhone() {
      // Пропуск ввода номера телефона
      await this.createUserWithOtp(null, null)
    },
    
    async createUserWithOtp(phone, code) {
      if (!this.temp_social_session_id) {
        this.hideWizard()
        return
      }
      
      try {
        const data = {
          session_id: this.temp_social_session_id
        }
        
        // Если номер телефона и код предоставлены, добавляем их
        if (phone && code) {
          data.phone = phone
          data.code = code
        }
        
        const response = await api.createUserFormWizard(data)
        
        // Проверяем, пришёл ли токен в ответе
        if (response && response.token) {
          // Вызываем finishAuth для установки токена и данных пользователя
          await this.finishAuth(response)
        } else {
          this.toast.success('Пользователь создан успешно')
          
          // Отмечаем шаг как выполненный
          if (phone && code) {
            this.phoneExists = true
            this.step1 = true
          }
        }
        
        return response
      } catch (error) {
        console.error('Ошибка создания пользователя:', error)
        
        // Если ошибка 401 - неверный токен
        if (error.response && error.response.status === 401) {
          this.toast.error('Неверный код')
          // Перезагружаем страницу для повторного ввода
          this.resetWizardLogin()
        } else if (error.response && error.response.status === 400) {
          // Ошибка 400 - выводим текст из response.data
          const errorMessage = error.response.data?.detail || error.response.data?.message || JSON.stringify(error.response.data)
          this.toast.error(errorMessage)
        } else {
          this.toast.error('Ошибка при создании пользователя')
        }
        throw error
      }
    },
    
    resetWizardLogin() {
      // Сбрасываем состояние WizardLogin для повторного ввода
      const wizardLoginComponent = this.$refs.wizardLogin
      if (wizardLoginComponent && wizardLoginComponent.resetStep) {
        wizardLoginComponent.resetStep()
      }
      // Сбрасываем данные OTP
      this.pendingOtpCode = null
      this.pendingPhone = null
    },

    handleAuthStatus({ phone_exists, vk_exists }) {
      this.phoneExists = phone_exists
      this.vkExists = vk_exists
    },

    completeStep1() {
      this.step1 = true
      this.phoneExists = true
    },

    completeStep2() {
      this.step2 = true
      this.vkExists = true
    },

    hideWizard() {
      console.log('[AuthWizard] hideWizard: ВЫЗВАН метод hideWizard()');
      console.log('[AuthWizard] hideWizard: this.hidden было', this.hidden);
      this.hidden = true
      console.log('[AuthWizard] hideWizard: this.hidden стало', this.hidden);
      console.log('[AuthWizard] hideWizard: ЭМИТ события "hide"');
      this.$emit("hide")
      console.log('[AuthWizard] hideWizard: событие "hide" ОТПРАВЛЕНО');
    },

    async finishAuth(data) {
      // Устанавливаем токен пользователя
      if (data.token) {
        this.SET_USER_TOKEN(data.token)
      }
      // Устанавливаем поля пользователя
      this.SET_USER_FIELDS(data)
      // Получаем детали пользователя
      await this.GET_USER_DETAILS()
      
      // Сбрасываем данные OTP
      this.pendingOtpCode = null
      this.pendingPhone = null
      
      // Запрашиваем актуальные данные авторизации
      await this.checkAuthStatus()
      
      // Показываем финальный экран (визард остаётся видимым)
      this.showFinalScreen = true
      
      this.$emit('success')
    },
    
    async checkAuthStatus() {
      try {
        const response = await api.checkAuth()
        this.phoneExists = response.phone_exists || false
        this.vkExists = response.vk_exists || false
      } catch (error) {
        console.error('Failed to check auth status:', error)
      }
    },

    fullAuthCompleted() {
      return this.phoneExists && this.vkExists
    },

    extractSessionId() {
      const query = this.$route.query
      if (query.session_id) {
        this.temp_social_session_id = query.session_id
      } else {
        this.toast.error('Отсутствует session_id в URL')
      }
    },

    checkWeAreAuth() {
      // Проверяем наличие куки .quiz_token
      const quizToken = document.cookie.split(';').find(cookie =>
        cookie.trim().startsWith('quiz_token=')
      )

      // Если кука найдена, проверяем её значение
      if (quizToken) {
        const value = quizToken.split('=')[1]
        // Возвращаем true только если значение не пустое и не null
        return value !== undefined && value !== null && value.trim() !== ''
      }

      return false
    },

    async createUserWithSession() {
      if (!this.temp_social_session_id) {
        this.toast.error('Отсутствует session_id')
        return
      }
      try {
        const data = {
          session_id: this.temp_social_session_id
        }
        const response = await api.createUserFormWizard(data)
        this.toast.success('Пользователь создан успешно')
        return response
      } catch (error) {
        console.error('Ошибка создания пользователя:', error)
        this.toast.error('Ошибка при создании пользователя')
        throw error
      }
    }

  }

}

</script>

<style scoped>

.auth-wizard-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.7);

  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-wizard-container {
  width: 360px;
  position: relative;
}

.wizard-card {
  background: #2f2c6a;
  border-radius: 20px;
  padding: 28px 24px;
  color: white;
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.description {
  font-size: 13px;
  line-height: 1.5;
  opacity: 0.85;
  margin-bottom: 22px;
}

.description p {
  margin-bottom: 10px;
}

.steps {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
}

.circle {
  width: 22px;
  height: 22px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: bold;
  color: white;
}

.success .circle {
  background: #00c853;
}

.error .circle {
  background: #ff3d00;
}

.wizard-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.btn {
  padding: 12px 20px;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.primary {
  background: linear-gradient(90deg,#ff2a8a,#ff007a);
  color: white;
}

.secondary {
  background: #3d3a80;
  color: white;
}

.final-screen {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}

.close-btn {
  position: absolute;
  right: -6px;
  top: -6px;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  border: none;

  background: rgba(255,255,255,0.1);
  color: white;

  font-size: 18px;
  cursor: pointer;
}

.close-btn:hover {
  background: rgba(255,255,255,0.2);
}

.vk-wrapper {
  margin-top: 20px;
  text-align: center;
}

.vk-text {
  font-size: 13px;
  margin-bottom: 12px;
  opacity: 0.9;
}

</style>
